import { IconProps } from "@mui/material";
import React from "react";

const HistoryIcon = ({className}:IconProps) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.473 14.027L14.527 12.973L10.75 9.196V4.5H9.25V9.80375L13.473 14.027ZM10.0017 19C8.68775 19 7.45267 18.7507 6.2965 18.252C5.14033 17.7533 4.13467 17.0766 3.2795 16.2218C2.42433 15.3669 1.74725 14.3617 1.24825 13.206C0.749417 12.0503 0.5 10.8156 0.5 9.50175C0.5 8.18775 0.749333 6.95267 1.248 5.7965C1.74667 4.64033 2.42342 3.63467 3.27825 2.7795C4.13308 1.92433 5.13833 1.24725 6.294 0.74825C7.44967 0.249417 8.68442 0 9.99825 0C11.3123 0 12.5473 0.249333 13.7035 0.748C14.8597 1.24667 15.8653 1.92342 16.7205 2.77825C17.5757 3.63308 18.2528 4.63833 18.7518 5.794C19.2506 6.94967 19.5 8.18442 19.5 9.49825C19.5 10.8123 19.2507 12.0473 18.752 13.2035C18.2533 14.3597 17.5766 15.3653 16.7218 16.2205C15.8669 17.0757 14.8617 17.7528 13.706 18.2518C12.5503 18.7506 11.3156 19 10.0017 19ZM10 17.5C12.2167 17.5 14.1042 16.7208 15.6625 15.1625C17.2208 13.6042 18 11.7167 18 9.5C18 7.28333 17.2208 5.39583 15.6625 3.8375C14.1042 2.27917 12.2167 1.5 10 1.5C7.78333 1.5 5.89583 2.27917 4.3375 3.8375C2.77917 5.39583 2 7.28333 2 9.5C2 11.7167 2.77917 13.6042 4.3375 15.1625C5.89583 16.7208 7.78333 17.5 10 17.5Z"
        fill="#12B6EA"
        className={className}
      />
    </svg>
  );
};

export default HistoryIcon;
